import React from 'react';
import { AppIcon } from '../../icons/appIcons.tsx';

export default function LogoMark({ className = 'h-10 w-10' }: { className?: string }) {
  return (
    <div className={`${className} rounded-lg bg-white p-1 flex items-center justify-center shrink-0`}>
      <AppIcon name="horse" className="w-full h-full text-ggaa-green p-0.5" strokeWidth={1.5} />
    </div>
  );
}
